<template>
  <div>
    <div><img src="../../assets/about/1.jpeg" class="fruit_img" /></div>
    <div style="" class="banner">联系我们</div>
    <div class="delivery">
      <div class="deliver_parent">
        <div class="delivery_border">
          <div class="flexStyle">
            <img
              class="delivery_border_img"
              src="./../../assets/about/1.png"
              style="height: 40px"
            />
          </div>
          <div>
            <div class="delivery_border_title">公司地址：</div>
            <div class="delivery_border_content">
              浙江省杭州市萧山区浦阳镇
            </div>
          </div>
        </div>
        <div class="delivery_border">
          <div class="flexStyle">
            <img class="delivery_border_img" src="../../assets/about/2.png" />
          </div>
          <div>
            <div class="delivery_border_title">销售热线：</div>
            <div class="delivery_border_content">李经理 18698569727</div>
          </div>
        </div>
        <div class="delivery_border">
          <div class="flexStyle">
            <img class="delivery_border_img" src="../../assets/about/3.png" />
          </div>
          <div>
            <div class="delivery_border_title">售后电话：</div>
            <div class="delivery_border_content">17506503697</div>
          </div>
        </div>
        <div class="delivery_border">
          <div class="flexStyle">
            <img
              class="delivery_border_img"
              src="../../assets/about/4.png"
              style="height: 25px"
            />
          </div>
          <div>
            <div class="delivery_border_title">邮箱</div>
            <div class="delivery_border_content">LXJ8707@163.com</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Fruit",
  data() {
    return {
      delivery: [
        {
          img: require("../../assets/other/定位图标.png"),
          title: "自定义配送范围",
          contents: ["商家后台自定义配送范围"],
        },
        {
          img: require("../../assets/other/骑车送.png"),
          title: "支持自定义配送",
          contents: ["商家自己优选配送路径"],
        },
        {
          img: require("../../assets/other/券.png"),
          title: "线上优惠券福利",
          contents: ["各种优惠福利提升用户消费"],
        },
      ],
    };
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.banner {
  font-size: 36px;
  font-weight: bold;
  margin-top: 60px;
  text-align: center;
}
.delivery_border {
  height: auto;
  margin: 20px;
  width: 50%;
  display: flex;
  /*border-radius: 6px;*/
  /*border: 1px solid #EBEEF5;*/
}

.delivery_border_img {
  margin-right: 20px;
  width: 30px;
  height: 35px;
}
.delivery_border_title {
  font-size: 1.25em;
  font-weight: normal;
}
.delivery_border_content {
  margin-top: 10px;
  font-size: 1.125em;
  font-weight: normal;
}
.fruit_img {
  height: 550px;
  width: 100%;
}
.fruit_product_img {
  height: 500px;
  width: 260px;
}
.deliver_parent {
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.deliver_img_parent {
  width: 30%;
  height: auto;
}
.delivery {
  display: flex;
  height: 550px;
  width: 90%;
  margin: auto;
  justify-content: center;
  align-items: center;
}

.flexStyle {
  display: flex;
  align-items: center;
}
/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .banner {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
  }
  .fruit_img {
    height: 180px;
    width: 100%;
  }
  .fruit_product_img {
    height: 400px;
    width: 240px;
  }
  .delivery_border_img {
    margin-top: 20px;
    width: 70px;
    height: 70px;
  }
  .deliver_img_parent {
    width: 100%;
    float: left;
    height: 400px;
  }
  .deliver_parent {
    float: left;
    margin-top: 5px;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
  }
  .delivery_border {
    height: auto;
    margin: 10px 0 auto;
    width: 100%;
    float: right;
    border-radius: 6px;
    border: none;
  }
  .delivery {
    display: flex;
    width: 90%;
    height: auto;
    margin: auto;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background:	#F5F5F5;
    padding: 0 5px;
    border-radius:4px ;
  }
  .delivery_border_title {
    font-size: 1.125em;
    font-weight: normal;
    width: 100%;
    padding-left: 4px;
    border-left:4px solid #df002e ;
  
  }
  .delivery_border_content {
    margin-top: 5px;
    font-size: 1em;
    font-weight: normal;
    margin-bottom: 10px;
      padding-left: 4px;
  }
  .flexStyle {
    display: none;
    align-items: center;
  }
}
</style>